import apiCore from '../../utils/api-core';

export function createBot(body) {
	return apiCore.post('/api/v1/bots', body);
}

export function getAssignedBots() {
	return apiCore.get(`/api/v1/user/bots`);
}

export function getUserCompanyBots() {
	return apiCore.get(`/api/v1/user/company/bots`);
}

export function getCompanyTags(){
	return apiCore.get(`/api/v1/user/company/tags`);
}


export function getCompanyTagsByCompanyId(id){
	return apiCore.get(`/api/v1/company/tags/${id}`);
}

export function getBotTemplates() {
	return apiCore.get(`/api/v1/bots/templates`);
}

export function getBotQRImage(filename) {
	return apiCore.get(`/api/v1/files/bot/qr/${filename}`);
}

export function getBot(id) {
	return apiCore.get(`/api/v1/bots/${id}`);
}

export function updateBot(id, body) {
	return apiCore.put(`/api/v1/bots/${id}`, body);
}

export function copyBot(sourceId, destId) {
	return apiCore.put(`/api/v1/bots/${sourceId}/copy/${destId}`);
}

export function getBots() {
	return apiCore.get('/api/v1/bots');
}

export function getBotsPerCompany(companyId) {
	return apiCore.get(`/api/v1/company/${companyId}/bots`);
}

export function assignBotToUser(botId, userId) {
	return apiCore.put(`/api/v1/bots/${botId}/users/${userId}`, {});
}

export function setStartModule(botId, moduleId) {
	return apiCore.put(`/api/v1/bots/${botId}/modules/${moduleId}`, {});
}

export function updateView(botmapId, data) {
	return apiCore.put(`/api/v1/bots/set-view/${botmapId}`, data);
}

export function getBotmap(botmapId) {
	return apiCore.get(`/api/v1/botmap/${botmapId}`);
}

export function getCompaniesWithBroadcastCampaignBots() {
	return apiCore.get('/api/v1/bots/broadcast-campaign/companies');
}

export function generateBotQR(data){
	return apiCore.post('/api/v1/files/gen/qr',data)
}

export function getBotChildren(botId) {
	return apiCore.get(`/api/v1/bot/${botId}/children`);
}